module.exports = __webpack_public_path__ + "static/media/2025-05-06-01.a43e5967.jpg";